<template>
  <span class="uppercase text-xs tracking-[.2rem] flex gap-4 items-center">
    <template v-if="article.authors?.length">
      by {{ article.authors[0].name }}
    </template>
    <template v-if="article.date">
      <span>|</span>
      {{ formatDate(article.date) }}
    </template>
  </span>
</template>

<script lang="ts" setup>
import type { BlogPost } from '~/types/blog-post';
defineProps<{
  article: BlogPost;
}>();
function formatDate(date: string) {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}
</script>
